import Vue from "vue";

export default Vue.extend({
  methods: {
    getFormattedIban(iban: string): string {
      let formattedIban = "";
      for (let i = 0; i < iban.length / 4; i++) {
        const j = i * 4;
        formattedIban += `${iban.substring(j, j + 4)} `;
      }
      return formattedIban;
    },
    getFormattedSsin(ssin: string, indexes: number[], separator: string): string {
      const ssinSplit = ssin?.split("");
      for (let i = 1; i <= indexes.length; i++) {
        ssinSplit?.splice(indexes[i - 1], 0, separator);
      }
      return ssinSplit?.reduce((a, b) => a + b);
    },
    validateSsin(ssin: string): boolean {
      ssin = ssin.trim();
      const match = ssin.match(/^(\d{2})([./]?)(\d{2})([./]?)(\d{2})(-?)(\d{3})([.-]?)(\d{2})$/);
      if (
        match &&
        ((match[2] == "" && match[4] == "" && match[6] == "" && match[8] == "") ||
          (match[2] == "." && match[4] == "." && match[6] == "-" && match[8] == ".") ||
          (match[2] == "." && match[4] == "." && match[6] == "-" && match[8] == "-") ||
          (match[2] == "" && match[4] == "" && match[6] == "-" && match[8] == "-") ||
          (match[2] == "/" && match[4] == "/" && match[6] == "-" && match[8] == "-")) &&
        (97 - (+(match[1] + match[3] + match[5] + match[7]) % 97) == +match[9] ||
          97 - (+("2" + match[1] + match[3] + match[5] + match[7]) % 97) == +match[9])
      ) {
        return true;
      }
      return false;
    },
  },
});
